import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { ICommitmentEditorItem } from '../../../components/widgets/public/partner360/commitment/models'

import { ICallAcknowledgmentActionParameters } from './models/callAcknowledgmentActionParameters'

export const callAcknowledgmentAction = async ({
  ownerId,
  ...payload
}: ICallAcknowledgmentActionParameters): Promise<ICommitmentEditorItem[]> => {
  const wsClient = WebSocketStore.get('partner360')
  const [token] = getTokens(ownerId)
  const { actionData, ...other } = payload

  try {
    const res = await wsClient.call<ICommitmentEditorItem[]>({
      service: 'acknowledgment',
      action: 'callAction',
      payload: { ...other, actionData: JSON.stringify(actionData) },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })
    return res.data
  } catch (e: any) {
    return []
  }
}
